if($('.id--17').length){
    $('label[for="billDistrict"]').text('Uveďte ID TianDe');
}
